import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'

@Component({
    selector: 'app-main',
    imports: [CommonModule],
    templateUrl: './main.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Main {
    bgColor = input<string>('')
    hasBorder = input<boolean>(true)
}
